import { gql, useQuery } from '@apollo/client'
import { getCacheableContext } from '@emico-utils/graphql-data-utils'

import { Breadcrumb, CategoryTree, Maybe } from '../../graphql/schema.generated'

const query = gql`
    query GetCategory($id: Int!) {
        category(id: $id) {
            id
            name
            urlKey
            metaTitle
            metaKeywords
            metaDescription
            metaRobots
            description
            breadcrumbs {
                categoryName
                categoryLevel
                categoryUrlKey
                categoryId
            }
            promotionBackgroundImage
            promotionButtonText
            promotionButtonLink
            promotionText
            promotionLink
        }
    }
`

export interface GetCategoryQueryVariables {
    id: number
}

export type CategoryBreadcrumb = Pick<
    Breadcrumb,
    'categoryName' | 'categoryLevel' | 'categoryUrlKey'
>

export type Category = Pick<
    CategoryTree,
    | 'id'
    | 'name'
    | 'urlKey'
    | 'description'
    | 'metaTitle'
    | 'metaKeywords'
    | 'metaRobots'
    | 'metaDescription'
    | 'breadcrumbs'
    | 'promotionBackgroundImage'
    | 'promotionButtonText'
    | 'promotionButtonLink'
    | 'promotionText'
    | 'promotionLink'
> & {
    breadcrumbs: Maybe<Array<Maybe<CategoryBreadcrumb>>>
}

export interface GetCategoryData {
    category: Category
}

export const useGetCategory = (id: number) => {
    const { data, ...others } = useQuery<
        GetCategoryData,
        GetCategoryQueryVariables
    >(query, {
        variables: {
            id,
        },
        fetchPolicy: 'cache-and-network',
        context: getCacheableContext(),
    })

    return {
        data: data?.category,
        ...others,
    }
}
